export default class SegmentIntersector {
  isDone() {}
  processIntersections(e0, segIndex0, e1, segIndex1) {}
}
